import React from 'react';
import ReactDOM from 'react-dom';
import 'antd/dist/antd.css';
import { Table, Button, Pagination, Space } from "antd";
import ReportCell from "../Cell/ReportCell";
import moment from 'moment';
import * as actions from '../../../../../store/actions/indexes';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';

const DisplayPagination = (props) => {
  return <span>{props.currentViewIndexes.min} - {(props.currentViewIndexes.max >= props.currentViewIndexes.actualCount) ? (props.currentViewIndexes.actualCount) : (props.currentViewIndexes.max)} of {(props.currentViewIndexes.axisName === null ? '' : props.currentViewIndexes.axisName)} {(props.currentViewIndexes.currentSet === 0) ? 0 : props.currentViewIndexes.actualCount}</span>

}

class HotelNavigation extends React.Component {
  constructor(props) {
    super(props);

    // console.log(this.props, "HotelNav....");
    // console.log(this.props.settings, "hotelNavigation")
    this.state = {
      currentViewIndexes: {
        min: this.props.settings.indexes.min, 
        max: this.props.settings.indexes.max, 
        currentSet: this.props.settings.indexes.currentSet, 
        actualCount: this.props.settings.indexes.actualCount, 
        axisName: this.props.settings.indexes.axisName, 
        set: this.props.settings.indexes.set, 
        // min: this.props.settings.indexes.min, max: this.props.settings.indexes.max, currentSet: this.props.settings.set
      }
    }
  }
  componentDidUpdate(prevProp, prevState) {
    //indexIncrease, indexReduce are two main function to navigate and view selected hotels, 
    //indexes are changing 2 by 2 but special cases such as odd number of hotels are selected and 
    //hotels are not selected, only one selected is selected are index numbering is handled below.
    // console.log(prevProp.settings, this.props.settings, "HotelNavigationHotelslist")
    // if (prevProp.settings !== this.props.settings) {
    //   this.setState({
    //     currentViewIndexes: {
    //       min: 1, max: this.props.settings.defaultCount, currentSet: this.props.settings.set
    //     }
    //   })
    // }
    // console.log(prevProp.settings, this.props.settings)
    if (prevProp.settings !== this.props.settings || prevProp.emptyData !== this.props.emptyData) {
      // console.log(this.props.settings.indexes, "settings.indexes....", this.props.selectedHotels.length)
      // console.log("currentViewIndexes......", this.state.currentViewIndexes)
      // console.log("props.settings.indexes......", prevProp.settings.indexes)
      if (this.props.emptyData != 0) {
        this.setState(state => {
          const currentViewIndexes = {
            min: this.props.settings.indexes.min, 
            max: this.props.settings.indexes.max, 
            currentSet: this.props.settings.indexes.currentSet, 
            actualCount: this.props.settings.indexes.actualCount,
            axisName: this.props.settings.indexes.axisName,
            set: this.props.settings.indexes.set
          }
          return { currentViewIndexes }
        })
      } else {
        // console.log(this.props.emptyData, "emptydata")
        this.setState(state => {
          const currentViewIndexes = {
            min: 0, 
            max: 0, 
            currentSet: 0, 
            actualCount: this.props.settings.indexes.actualCount, 
            axisName: this.props.settings.indexes.axisName,
            set: this.props.settings.indexes.set
            // min: 0, max: 0, currentSet: -1
          }
          return { currentViewIndexes }
        })
      }
    }


    // console.log(this.props.settings.indexes, "settings.indexes....")
    // console.log("currentViewIndexes......", this.state.currentViewIndexes)
    // console.log("props.settings.indexes......", prevProp.settings.indexes)
    // if (prevProp.selectedHotels !== this.props.selectedHotels) {
    //   this.setState(state => {
    //     let n_1;
    //     let n_2;
    //     if (this.props.selectedHotels.length == 1) {
    //       n_1 = 0;
    //       n_2 = 1;
    //     }
    //     else if (this.props.selectedHotels.length == 0) {
    //       n_1 = 0;
    //       n_2 = 0;
    //     }
    //     else {
    //       n_1 = 1;
    //       n_2 = 2;
    //     }

    //     const currentViewIndexes = {
    //       firstnode: { min: 1, max: (this.props.selectedHotels.length - 1), current: n_1 },
    //       secondnode: { min: 2, max: (this.props.selectedHotels.length), current: n_2 }
    //     }
    //     return {
    //       currentViewIndexes
    //     }
    //   })
    // }
  }
  indexIncrease = () => {
    //When max value is odd and two hotels displaying need to be consistent
    if (this.state.currentViewIndexes.max < this.props.settings.indexes.actualCount) {
      let nextMax = 0, nextMin = 0;
      this.setState((state, props) => {
        let nextSet = state.currentViewIndexes.max + this.props.settings.defaultCount;
        // console.log(nextSet, "nextSet....", props.selectedHotels.length, state.currentViewIndexes.max)
        if (nextSet > this.props.settings.indexes.actualCount ) {
          nextMax = this.props.settings.indexes.actualCount;
          nextMin = (state.currentViewIndexes.max + 1);
        } else {
          nextMax = nextSet;
          nextMin = (state.currentViewIndexes.max + 1);
        }
        let nextSetNo = state.currentViewIndexes.currentSet + 1;
        // console.log(nextMin, nextMin, nextSetNo, nextSet)

        const currentViewIndexes = {
          min: nextMin, 
          max: nextMax, 
          currentSet: nextSetNo, 
          actualCount: this.props.settings.indexes.actualCount,
          axisName: this.props.settings.indexes.axisName,
          set: this.props.settings.indexes.set
        }
        // console.log(currentViewIndexes, "Nav Plus")
        this.changeHotelView(currentViewIndexes);
        return { currentViewIndexes }
      })

    }
    //regular page navigation with indexes
    // else if (this.state.currentViewIndexes.secondnode.current + value <= this.state.currentViewIndexes.secondnode.max) {
    //   // this.changeHotelView(this.state.currentViewIndexes.firstnode.current + value, this.state.currentViewIndexes.secondnode.current + value);
    //   this.setState(state => {
    //     const _update_n_1 = state.currentViewIndexes.firstnode.current + value;
    //     const _update_n_2 = state.currentViewIndexes.secondnode.current + value;
    //     const currentViewIndexes = {
    //       firstnode: { min: 1, max: (this.props.selectedHotels.length - 1), current: _update_n_1 },
    //       secondnode: { min: 2, max: (this.props.selectedHotels.length), current: _update_n_2 }
    //     }
    //     return {
    //       currentViewIndexes
    //     }
    //   })
    // }
  }
  indexReduce = () => {
    //intention of the condition following here to change current pagination number system and table view of hotel for better UX way
    // i.e current navigation first and second node got 4-5 respectively with second node max value is 5, in such case user go back (left arrow:one button click) navigation system readjust the number such as 3-4 but not 2-3
    // but other all cases, first and second nodes are counting back and forth in 2 by 2.
    // if (this.state.currentViewIndexes.secondnode.max == this.state.currentViewIndexes.secondnode.current && this.props.selectedHotels.length % 2 == 1) {
    //   this.changeHotelView(this.state.currentViewIndexes.secondnode.current + value, this.state.currentViewIndexes.firstnode.current);
    //   this.setState(state => {
    //     const _update_n_1 = state.currentViewIndexes.secondnode.current + value;
    //     const _update_n_2 = state.currentViewIndexes.firstnode.current;
    //     const currentViewIndexes = {
    //       firstnode: { min: 1, max: (this.props.selectedHotels.length - 1), current: _update_n_1 },
    //       secondnode: { min: 2, max: (this.props.selectedHotels.length), current: _update_n_2 }
    //     }
    //     return {
    //       currentViewIndexes
    //     }
    //   })
    // }
    // else if (this.state.currentViewIndexes.firstnode.current + value >= this.state.currentViewIndexes.firstnode.min) {
    //   this.changeHotelView(this.state.currentViewIndexes.firstnode.current + value, this.state.currentViewIndexes.secondnode.current + value);
    //   this.setState(state => {
    //     const _update_n_1 = state.currentViewIndexes.firstnode.current + value;
    //     const _update_n_2 = state.currentViewIndexes.secondnode.current + value;
    //     const currentViewIndexes = {
    //       firstnode: { min: 1, max: (this.props.selectedHotels.length - 1), current: _update_n_1 },
    //       secondnode: { min: 2, max: (this.props.selectedHotels.length), current: _update_n_2 }
    //     }
    //     return {
    //       currentViewIndexes
    //     }
    //   })
    // }
    if (this.state.currentViewIndexes.min > 1) {
      // this.changeHotelView(this.state.currentViewIndexes.secondnode.current, this.state.currentViewIndexes.secondnode.max);
      let prevMax = 0, prevMin = 0;
      this.setState((state, props) => {
        let prevSet = 0;
        let modules = (state.currentViewIndexes.max % props.settings.defaultCount);
        if (modules == 0) {
          prevSet = state.currentViewIndexes.max - props.settings.defaultCount
        } else {
          prevSet = state.currentViewIndexes.max - modules;
        }
        // console.log(prevSet, "prevSet.....", modules)
        if (prevSet <= props.settings.defaultCount) {
          prevMax = props.settings.defaultCount;
          prevMin = 1;
        } else {
          prevMax = prevSet;
          prevMin = prevSet - props.settings.defaultCount;
          // console.log(prevMin, "prevMin")
        }

        let prevSetNo = state.currentViewIndexes.currentSet - 1;
        // console.log(prevMax, prevMin, prevSetNo, prevSet)
        const currentViewIndexes = {
          min: prevMin, 
          max: prevMax, 
          currentSet: prevSetNo, 
          actualCount: this.props.settings.indexes.actualCount,
          axisName: this.props.settings.indexes.axisName,
          set: this.props.settings.indexes.set
        }
        // console.log(currentViewIndexes, "Nav Minus")
        this.changeHotelView(currentViewIndexes);
        return { currentViewIndexes }
      })
    }
  }

  changeHotelView = (value) => {
    //index changes need to notify and update parent components are compulsory.
    this.props.changeHotelViewEvent(value);
  }
  render() {
    return (
      <div className="tblNavigation">
        <Button onClick={() => this.indexReduce()} icon={<LeftOutlined />} disabled={
          (this.state.currentViewIndexes.min <= 1)
        }></Button>
        <DisplayPagination currentViewIndexes={this.state.currentViewIndexes} />
        <Button onClick={() => this.indexIncrease()} icon={<RightOutlined />} disabled={
          (this.state.currentViewIndexes.max === 0 || this.state.currentViewIndexes.max >= this.props.settings.indexes.actualCount)
        }></Button>
        {/* {console.log(this.state.currentViewIndexes, "max, min", this.props.selectedHotels)} */}
      </div>
    )
  }
}
export default HotelNavigation;